export default __webpack_public_path__ + "857104d2a47842f703a77121c9904311.png";